// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar-component[data-v-7cca3702] img{-o-object-fit:var(--object-fit);object-fit:var(--object-fit)}", "",{"version":3,"sources":["webpack://./resources/app/components/Avatar.vue"],"names":[],"mappings":"AAGE,uCACE,+BAAA,CAAA,4BAFJ","sourcesContent":["\n\n.avatar-component {\n  ::v-deep(img) {\n    object-fit: var(--object-fit);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
